// Business flags
export const LENDER_ESIGN = "lender-esign";
export const PROOF_TRANSACTIONS = "proof-transactions";
export const REFERRAL_CAMPAIGNS_ANNOUNCEMENT = "referral-campaigns-announcement";
export const SIGN_AHEAD = "sign_ahead";
export const TRANSACTION_LEVEL_PAYER_CONFIGURATION = "transaction-level-payer-configuration";
export const SPLIT_BOOKMARKED_PDF_IN_TRANSACTION_UI = "split-bookmarked-pdf-in-transaction-ui";
export const HYBRID_REQUIRES_ACCOUNT = "hybrid-portal-requires-account";
export const HIDE_ESIGN_FROM_NEW_TRANSACTION_DROPDOWN = "hide-esign-from-new-transaction-dropdown";
export const BUSINESS_TEMPLATE_NEW_FEATURE = "new-feature-business-templates-popup";
export const IA_NAV = "ia-nav";
export const ERBAC_USER_MANAGER_ENABLED = "enterprise-user-manager-role";
export const MOBILE_BUSINESS_PORTAL = "mobile-business-portal";
export const REFERRAL_CAMPAIGNS_P2 = "referral-campaigns-p2";
export const RECIPIENT_ORDER = "recipient-order";
export const SELF_SERVE_FORCE_COMPLETE = "self-serve-force-complete";
export const ORGANIZATION_BRAND_NAME = "organization-brand-name";
export const TEAM_MANAGEMENT_IMPROVEMENTS = "team-mgmt-improvements";
export const MULTISIGNER_EASYLINK = "multisigner-easylink";

// Real Estate Flags
export const ENABLE_ENOTES_IN_HYBRIDS = "enable-enotes-in-hybrids";
export const CONVERT_RON_TO_HYBRID = "convert-ron-to-hybrid";
export const NOTARY_ROUTING_RULES = "notary-routing-rules-check";

// Document Flags

// Signer Flags
export const DEEP_LINK = "deep_link_texts";
export const WEB_DOC_SCANNING = "web-doc-scanning";
export const GROWTH_LANDING_PAGES_ENABLED = "growth-landing-pages-enabled";

// Signer & Notary Flag
export const DISABLE_NOTAGIG_SIGNUP_REFERRAL = "disable-notagig-signup-referral";

//Org Flags
export const REAL_ESTATE_COLLAB_ENABLED = "realEstateCollabEnabled";
export const NON_ONBOARDED_TITLE_ENABLED = "nonOnboardedTitleEnabled";
